<desy-button
  classes="bg-alert-base border-alert-base c-button c-button--primary ng-star-inserted content-center flex-wrap"
  style="align-content: center">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 140 140"
    class="self-center my-1"
    focusable="false"
    width="1em"
    height="1em"
    role="img"
    aria-label="Borrar">
    <path
      d="M113.72 61.66A5 5 0 00110 60H30a5 5 0 00-5 5.53l7.5 70a5 5 0 005 4.47h65a5 5 0 005-4.47l7.5-70a5 5 0 00-1.28-3.87zM125 27.92h-25a2.5 2.5 0 01-2.5-2.5V17.5A17.52 17.52 0 0080 0H60a17.58 17.58 0 00-17.5 17.23l-.12 8.22a2.51 2.51 0 01-2.5 2.47H15a10 10 0 000 20h110a10 10 0 000-20zM57.5 17.46A2.51 2.51 0 0160 15h20a2.5 2.5 0 012.5 2.5v7.92a2.5 2.5 0 01-2.5 2.5H59.88a2.51 2.51 0 01-2.5-2.54z"
      fill="currentColor"></path>
  </svg>
</desy-button>
